import { c as _c } from "react/compiler-runtime";
import { useQuery } from "@tanstack/react-query";
import { importQuery } from "../../services/payments/ImportQueryService";
import { queryKeys } from "@/utils/queryKeys";
const startOfToday = (): string => {
  const now = new Date();
  const year = now.getFullYear();
  const month = String(now.getMonth() + 1).padStart(2, "0");
  const day = String(now.getDate()).padStart(2, "0");
  return `${year}-${month}-${day} 00:00:00`;
};
export const useHasSofibImportToday = t0 => {
  const $ = _c(6);
  const enabled = t0 === undefined ? true : t0;
  let dayStart;
  let t1;
  let t2;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    dayStart = startOfToday();
    t2 = useQuery;
    t1 = queryKeys.payments.imports({
      sofibDoneSince: dayStart
    });
    $[0] = dayStart;
    $[1] = t1;
    $[2] = t2;
  } else {
    dayStart = $[0];
    t1 = $[1];
    t2 = $[2];
  }
  let t3;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = async () => {
      const response = await importQuery.search({
        search: {
          filters: [{
            field: "type",
            operator: "=",
            value: "national_transfers_sofib"
          }, {
            field: "status",
            operator: "=",
            value: "success"
          }, {
            field: "created_at",
            operator: ">=",
            value: dayStart
          }],
          limit: 10
        }
      });
      return response.data.length > 0;
    };
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  let t4;
  if ($[4] !== enabled) {
    t4 = {
      queryKey: t1,
      enabled,
      queryFn: t3
    };
    $[4] = enabled;
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  return t2(t4);
};